export const removeTrailingBlankSpace = (text: string) => {
  const regex = new RegExp('<p><br></p>$')
  if (regex.test(text)) {
    return text.substring(0, text.length - 11)
  } else {
    return text
  }
}

/**
 * Remove trailing blank space from rich text fields
 * @param values - The values to remove trailing blank space from
 * @param richTextFieldNames - The names of the rich text fields to remove trailing blank space from
 * @returns The values with trailing blank space removed from the rich text fields
 */
export const mapFormWithQuill = (values: any, richTextFieldNames: string[]) => {
  const newValues: any = values
  richTextFieldNames.forEach(
    richTextFieldName =>
      (newValues[richTextFieldName] = removeTrailingBlankSpace(
        values[richTextFieldName] as string,
      )),
  )
  return newValues
}

export const extractStringFromHTML = (HTML: string) =>
  HTML.replace(/<(.|\n)*?>/g, '').trim()

export const getInitialLetter = (text: string) => {
  return text.charAt(0)
}

export const returnBoldText = (text: string) => {
  return <b>{text}</b>
}
